import { RigidBody } from '@/src/abstract/RigidBody';

export class Target extends RigidBody {
  update() {}
}
